import validate from "/app/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.22_db0@0.3_83a3ca80bb69500b17f0f7fb5ed35e48/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@vue+compiler-sfc@3.5.22_db0@0.3_83a3ca80bb69500b17f0f7fb5ed35e48/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}